/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S8_C_Li6Inputs */

const tr_mesafeli_s8_c_li6 = /** @type {(inputs: Mesafeli_S8_C_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tersine mühendislik, sömürü veya altyapı zorlama girişimlerinden kaçınmak.`)
};

const en_mesafeli_s8_c_li6 = /** @type {(inputs: Mesafeli_S8_C_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To refrain from reverse engineering, exploitation or attempts to strain the infrastructure.`)
};

const de_mesafeli_s8_c_li6 = /** @type {(inputs: Mesafeli_S8_C_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von Reverse Engineering, missbräuchlicher Ausnutzung oder Überlastungsversuchen gegen die Infrastruktur absehen.`)
};

const ru_mesafeli_s8_c_li6 = /** @type {(inputs: Mesafeli_S8_C_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Воздерживаться от обратной разработки, эксплуатации уязвимостей и попыток перегрузки инфраструктуры.`)
};

/**
* | output |
* | --- |
* | "To refrain from reverse engineering, exploitation or attempts to strain the infrastructure." |
*
* @param {Mesafeli_S8_C_Li6Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s8_c_li6 = /** @type {((inputs?: Mesafeli_S8_C_Li6Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S8_C_Li6Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s8_c_li6(inputs)
	if (locale === "de") return de_mesafeli_s8_c_li6(inputs)
	if (locale === "ru") return ru_mesafeli_s8_c_li6(inputs)
	return tr_mesafeli_s8_c_li6(inputs)
});